export default {"src":"/_next/static/media/more.be2baa3e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};